import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"main_board",
    list_id:"main_board_list",
    x_column_list_arr:[
      // {"key":"row_view_manage","name":"관리","width":"80","is_show":"1"},
      // {"key":"a_public_sort","name":"공개","width":"80","is_show":"1"},
      {"key":"a_title","name":"제목","width":"280","is_show":"1"},
      {"key":"row_vew_is_popup","name":"팝업","width":"100","is_show":"1"},
      {"key":"a_writer","name":"작성자","width":"110","is_show":"1"},
      // {"key":"a_read_cnt","name":"조회수","width":"90","is_show":"1"},
      {"key":"a_create_date","name":"작성일","width":"120","is_show":"1"},
      // {"key":"a_update_date","name":"수정일","width":"90","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':20,
      'order_id':'a_create_date DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;